define(["komplett-pubsub"], function (pubsub) {
    /* eslint-disable no-unused-vars */
    var events = {
        cartUpdated: function (shoppingCartSummary) { },
        cartCleared: function () { },
        cartNewItem: function (shoppingCartSummary) { },
        shoppingCartLoadingChanged: function (isLoading) { },
    };
    /* eslint-enable no-unused-vars */

    return pubsub.extend(events);
});